import { createStore, applyMiddleware } from "redux";
import reducers, { initialState } from "./reducers";
import thunk from "redux-thunk";
export var store = createStore(
/* @ts-ignore */
reducers, initialState, applyMiddleware(thunk));
